import { render } from "./HelloWorld.vue?vue&type=template&id=7f2e2807"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=7f2e2807&lang=css"
script.render = render

export default script